import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Category from '../Category/category';
import styles from './categoryList.module.scss';
import { fetchKpiMasterDetails, getTargetFormat } from './categoryListUtil';

const CategoryList = ({ updateKpiDetails, kpiDetailsRefs, isEdit, kpiDetails}) => {
  const [categories, setCategories] = useState([]);
  const [targetFormatList, setTargetFormatList] = useState([]);
  const [selectedKpis, setSelectedKpis] = useState([]); // Track selected KPI values

  useEffect(() => {
    //  set the state from backend data, for now using dummy data
    if (isEdit) {
      const tempData = [];
      kpiDetails?.forEach((data) => {
        let index = 0;
        data.kpiOptions?.forEach((option) => {
          const rowId = ++index;
          const value = {
            id: option.kpiNameId,
            name: option.kpiName,
          };
          const categoryId = data.kpiCategoryId;

          if (option.targetFormatValue === 'yes') {
            option.targetFormatValue = 'Yes';
          }
          if (option.targetFormatValue === 'no') {
            option.targetFormatValue = 'No';
          }

          handleKpiChange(rowId, value, categoryId);
          // Perform any desired operations on each option here
        });
        tempData.push(data);
      });
      fetchKpiMasterDetails().then((fetchedCategories) => {
        const filteredCategories = fetchedCategories.filter(
          (fetchedCategory) => !tempData.some(isCategoryIdMatching(fetchedCategory)),
        );
        const combinedCategories = [...tempData, ...filteredCategories];
        combinedCategories.sort((categoryA, categoryB) => categoryA.kpiCategoryId - categoryB.kpiCategoryId);
        setCategories(combinedCategories);
      });

      const isCategoryIdMatching = (fetchedCategory) => (tempCategory) =>
        tempCategory.kpiCategoryId === fetchedCategory.kpiCategoryId;
    } else {
      fetchKpiMasterDetails().then(setCategories);
    }
    getTargetFormat().then(setTargetFormatList);
  }, [isEdit]);

  const handleKpiChange = useCallback((rowId, value, categoryId) => {
    setSelectedKpis((prevSelectedKpis) => {
      const newSelectedKpis = [...prevSelectedKpis];
      const index = newSelectedKpis.findIndex((kpi) => {
        return (kpi.rowId === rowId && kpi.categoryId === categoryId);
      });
      if (index !== -1) {
        newSelectedKpis[index].value = value;
      } else {
        newSelectedKpis.push({ rowId, value, categoryId });
      }
      return newSelectedKpis;
    });
  }, []);

  return (
    <section className={styles.container}>
      {categories.map((category, index) => (
        <Category
          id={category.kpiCategoryId}
          dropdownData={category?.kpiOptions}
          title={category.kpiCategory}
          ref={(el) => {
            kpiDetailsRefs.current[index] = el;
          }}
          key={category.kpiCategoryId}
          targetFormatList={targetFormatList}
          updateKpiDetails={updateKpiDetails}
          isEdit={isEdit}
          selectedKpis={selectedKpis}
          onKpiChange={handleKpiChange}
          setSelectedKpis={setSelectedKpis}
        />
      ))}
    </section>
  );
};

CategoryList.propTypes = {
  updateKpiDetails: PropTypes.func,
  kpiDetailsRefs: PropTypes.shape({
    current: PropTypes.arrayOf(
      PropTypes.shape({
        getKPIs: PropTypes.func.isRequired,
        // eslint-disable-next-line comma-dangle
      })
    ),
  }),
  isEdit: PropTypes.bool,
  kpiDetails: PropTypes.array,
};

export default CategoryList;
